import {getAxiosInstance, requestConfig} from "../../http-common";

const RESOURCE_NAME = 'tablefields';

const getAllFrom = (id: number) => {
    const http = getAxiosInstance();
    return http.get(`${RESOURCE_NAME}/from?fromTableId=${id}`, requestConfig());
};

const TableFieldsService = {
    getAllFrom,
};
export default TableFieldsService;


